import type { FunctionComponent, PropsWithChildren, RefObject } from 'react';
import { createContext, useContext, useState } from 'react';

export interface IVideoRefContext {
  videoRef: RefObject<HTMLVideoElement | null>;
  setVideoRef: (ref: RefObject<HTMLVideoElement | null>) => void;
}

export const VideoRefContext = createContext<IVideoRefContext>({
  videoRef: { current: null },
  setVideoRef: () => {},
});

export const useVideoRef = (): IVideoRefContext => {
  return useContext(VideoRefContext);
};

export const VideoRefContextProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const [videoRef, setVideoRef] = useState<IVideoRefContext['videoRef']>({ current: null });

  return <VideoRefContext.Provider value={{ videoRef, setVideoRef }}>{children}</VideoRefContext.Provider>;
};
